<template>
	<aside>
        <div v-if=" type !== 'query'">
            <compFormEdit class="margin-15 clearfix" ref="baseform" :formdata="getBase" v-model="formData" :labelWidth="200" />
        </div>
        <compWrapper v-else :title="$t('global.common.base_information',{defaultValue:'基本信息'})" >
            <div>
                <compFormQuery v-if="type=='query'" :formdata="getBase" :value="formData" :labelWidth="200"></compFormQuery>
                <compFormEdit v-else class="margin-15 clearfix" ref="baseform" :formdata="getBase" v-model="formData" :labelWidth="200" />
            </div>
        </compWrapper>
		<vButtonGroup class="text-right margin-top-15" v-if="type !== 'query'">
			<vButton theme="primary" @click="submit">确定</vButton>
			<vButton @click="close">取消</vButton>
		</vButtonGroup>
        <!-- 操作历史 -->
        <compWrapper title="操作历史" v-if="type=='query'">
            <compLog class="margin-15" :data="opLogList" :columns="getLogcolumns"></compLog>
        </compWrapper>
		<vLoading size="large" fix :loading="loading"></vLoading>
	</aside>
</template>
<script>
import { HttpBillCoefficientDetail, HttpBillCoefficientUpdate } from '@/service/costbilling';
import { HttpGetCusLineList } from '@/service/billing'
import { HttpProductList } from '@mods/service/dictionary';
import { mapGetters } from 'vuex';
import mixin from '../mixin';
export default {
	mixins: [mixin],
    props: [ 'querytype', 'activeids', 'querybox' ],
	components: {
		compWrapper: () => import("@components/templates/wrapper"),
		compFormEdit: () => import('@components/templates/formedit'),
	},
	data() {
		return {
            id: this.$route.query.id || this.activeids,
            type: this.$route.params.type || this.querytype,
            isBox: this.querybox || false,
			loading: false,
			formData: {},
            opLogList: [],
            lineList: [],
		};
	},
	created() {
        this.update();
	},
	computed: {
        ...mapGetters('dictionary', ['getBillcusorgList', 'getCusproductList']),
		getBase() {
			return [
				{
					label: this.$t('fbb.alloment.client_organization', { defaultValue: '客户' }),
					tag: 'vSelect',
					key: 'orgId',
					options: this.getBillcusorgList,
					props: {
                        filterable: true,
                    },
                    span: this.isBox ? 23 : undefined,
                    query: this.type !== 'add',
                    on:{
                        'on-change':(val)=>{
                            this.loading = true
                            HttpProductList({contextId:val}).then(res=>{
                                this.loading = false
                                this.lineList = res.data;
                            },err=>{
                                this.loading = false
                                this.$VMessage.error(err.message);
                            })
                        }
                    }
				},
				{
					label: this.$t('global.common.project', { defaultValue: "项目" }),
					key: 'lineId',
					tag: 'vSelect',
					options: this.lineList.map(item=>{
                        return {value: item.id, label: item.name}
                    }),
                    required: false,
                    span: this.isBox ? 23 : undefined,
					props: {
                        filterable: true,
                    },
                    show: this.type !== 'query'
				},
                {
					label: this.$t('global.common.project', { defaultValue: "项目" }),
					key: 'lineId',
                    render: () =>{
                        return this.findRenderLabel( this.getCusproductList, this.formData.lineId ) || '--'
                    },
                    show: this.type === 'query'
				},
                {
                    label: "仓储费-常规件计费系数",
                    key: 'normalCoefficient',
					tag: 'vInputNumber',
                    span: this.isBox ? 23 : undefined,
                    props: {
						min: 0,
					},
                    required: false,
                },
                {
                    label: "仓储费-异形件计费系数",
                    key: 'specialCoefficient',
					tag: 'vInputNumber',
                    span: this.isBox ? 23 : undefined,
                    props: {
						min: 0,
					},
                    required: false,
                },
                {
                    label: "仓储费-超异形件计费系数",
                    key: 'superSpecialCoefficient',
					tag: 'vInputNumber',
                    span: this.isBox ? 23 : undefined,
                    props: {
						min: 0,
					},
                    required: false,
                },
			]
		},
        getLogcolumns(){
			return [
				{
					title: this.$t('global.common.operator', { defaultValue: '操作人' }),
					key: "updatedName"
				},
				{
					title: this.$t('global.common.operate_type', { defaultValue: '操作类型' }),
					key: "operateType",
                    render:(h,{row})=>{
                        return <div>{row.operateType == 100 ?
                            this.$t('global.common.create', { defaultValue: "创建" }) :
                            this.$t('fbb.alloment.update	', { defaultValue: "更新" })}
                        </div>
                    }
				},
				{
					title: this.$t('global.common.notes', { defaultValue: '备注' }),
					key: "opData",
                    render:(h,{row})=>{
                        return <div>{row.opData || '--'}
                        </div>
                    }
				},
				{
					title: this.$t('global.common.createdtime', { defaultValue: '创建时间' }),
					key: "createdAt"
				}
			];
		}
	},
	methods: {
		async update() {
            if(this.type == 'add') return
			this.loading = true
            HttpBillCoefficientDetail({
                id:this.id
            }).then(res=>{
                HttpProductList({contextId: res.data.orgId}).then(res=>{
                        this.loading = false
                        this.lineList = res.data;
                    },err=>{
                        this.loading = false
                        this.$VMessage.error(err.message);
                    })
                this.formData = res.data;
                this.opLogList = res.data.logList
            },err=>{
                this.loading = false;
                this.$VMessage.error({
                    content: err.message,
                    duration: 30,
                    closable: true
                });
            })
		},
		close() {
			this.$emit('on-close')
		},
		async submit() {
			const valid = await this.$refs.baseform.validate();
			if (!valid) return;
			this.loading = true
			HttpBillCoefficientUpdate(this.formData).then(res => {
				this.$VMessage.success(res.message);
				this.close();
				this.$emit('on-update');
			}, err => {
				this.loading = false;
				this.$VMessage.error(err.message);
			})
		}
	}
};
</script>
